import { render, staticRenderFns } from "./BusinessTools.vue?vue&type=template&id=23dc3bff&scoped=true&"
import script from "./BusinessTools.vue?vue&type=script&lang=js&"
export * from "./BusinessTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc3bff",
  null
  
)

export default component.exports